<div class="nav-page-container">
  <div class="company-header-info">
    <app-valuation-info-header
      [showGlobalSettingsButton]="false"
      [callForNAV]="true"
    ></app-valuation-info-header>
  </div>
  <div class="grid-controls-container">
    <app-company-nav-grid-controls
      [ticker]="currentTicker"
      (dataSettingsChanged)="gridDataSettingsChanged($event)"
      (getSourcesInfo)="updateSourcesInfo($event)"
      [(metaInfo)]="metaInfo"
    ></app-company-nav-grid-controls>
  </div>
  <div class="nav-grid-container">
    <app-company-nav-grid
      [(metaLoading)]="metaLoading"
      [(currentTicker)]="currentTicker"
      [(metaInfo)]="metaInfo"
      [(dataSettings)]="dataSettings"
    ></app-company-nav-grid>
  </div>
</div>
